export default __webpack_public_path__ + "static/main-background-2630392abd6224e0c51998c344ecbbef.png";